import React from "react";
import Grid from "../../assets/Grid.png";

import consistentTrips from '../../assets/consistent_trip.webp'
import allInOneDriver from '../../assets/all_in_one_drive_app.webp'
import HigherEarnings from '../../assets/higher_earnings.webp'
import OnTimePayments from '../../assets/on_time_payment.webp'

const DriverSection2 = () => {
 return (
  <div
    className="bg-cover bg-center bg-no-repeat py-8 sm:py-10 md:py-12"
    style={{ backgroundImage: `url(${Grid})` }}
  >
    <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
      <h1 className="text-center text-[22px] md:text-[28px] font-semibold leading-tight sm:text-3x text-[#212529]">
        Why Partner With Packky
      </h1>

      <p className="mx-auto mt-3 mb-8 max-w-2xl text-center text-[16px] font-medium leading-6 text-gray-500 sm:text-base md:text-lg lg:text-[20px]">
        Drive your future further with benefits, flexibilikty and real earnings.
      </p>

      <div className="space-y-10 sm:space-y-12 md:space-y-14">
        {/* 1 */}
        <div className="grid items-center gap-6 md:grid-cols-2 md:gap-10 lg:gap-14">
          <div className="service-card-67 text-center md:text-left">
            <h3 className="text-[22px] font-semibold sm:text-[24px] md:text-[26px] text-[#212529]">
              Consistent Trips
            </h3>

            <p className="mx-auto mt-3 max-w-[500px] text-[15px] leading-6 text-gray-500 sm:text-base md:mx-0 md:text-lg lg:text-[1.25rem]">
              Packky's expanding network across multiple cities ensures a steady
              flow of delivery requests. You stay active with consistent trips
              throughout the day.
            </p>
          </div>

          <div className="flex justify-center md:justify-end">
            <img
              src={consistentTrips}
              className="h-auto w-full max-w-[420px] rounded object-contain sm:max-w-[480px] md:max-h-[350px]"
              alt="Real Time Order Tracking"
            />
          </div>
        </div>

        {/* 2 */}
        <div className="grid items-center gap-6 md:grid-cols-2 md:gap-10 lg:gap-14">
          <div className="service-card-67 order-1 text-center md:order-2 md:text-left">
            <h3 className="text-[22px] font-semibold sm:text-[24px] md:text-[26px] text-[#212529]">
              All-in-One Driver App
            </h3>

            <p className="mx-auto mt-3 max-w-[550px] text-[15px] leading-6 text-gray-500 sm:text-base md:mx-0 md:text-lg lg:text-[1.25rem]">
              Access trips, manage deliveries, track your income, and reach
              support anytime with our simple and feature-packed driver app build
              for a smooth experience.
            </p>
          </div>

          <div className="order-2 flex justify-center md:order-1 md:justify-start">
            <img
              src={allInOneDriver}
              className="h-auto w-full max-w-[420px] rounded object-contain sm:max-w-[480px] md:max-h-[350px]"
              alt="Smart Route Optimization"
            />
          </div>
        </div>

        {/* 3 */}
        <div className="grid items-center gap-6 md:grid-cols-2 md:gap-10 lg:gap-14">
          <div className="service-card-67 text-center md:text-left">
            <h3 className="text-[22px] font-semibold sm:text-[24px] md:text-[26px] text-[#212529]">
              Higher Earnings
            </h3>

            <p className="mx-auto mt-3 max-w-[550px] text-[15px] leading-6 text-gray-500 sm:text-base md:mx-0 md:text-lg lg:text-[1.25rem]">
              Partnet with a platform designed to boost your income. HIgh demand
              and efficient trip allocation help you complete more orders and
              earn more.
            </p>
          </div>

          <div className="flex justify-center md:justify-end">
            <img
              src={HigherEarnings}
              className="h-auto w-full max-w-[420px] rounded object-contain sm:max-w-[480px] md:max-h-[350px]"
              alt="Driver Management"
            />
          </div>
        </div>

        {/* 4 */}
        <div className="grid items-center gap-6 md:grid-cols-2 md:gap-10 lg:gap-14">
          <div className="service-card-67 order-1 text-center md:order-2 md:text-left">
            <h3 className="text-[22px] font-semibold sm:text-[24px] md:text-[26px] text-[#212529]">
              On-Time Paymnet
            </h3>

            <p className="mx-auto mt-3 max-w-[570px] text-[15px] leading-6 text-gray-500 sm:text-base md:mx-0 md:text-lg lg:text-[1.25rem]">
              We value your work and time. Packky ensures timely payments
              directly to your account with complete transparency and no delays.
            </p>
          </div>

          <div className="order-2 flex justify-center md:order-1 md:justify-start">
            <img
              src={OnTimePayments}
              className="h-auto w-full max-w-[420px] rounded object-contain sm:max-w-[480px] md:max-h-[350px]"
              alt="Customer Notifications"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);
};

export default DriverSection2;
